export default __webpack_public_path__ + "static/media/Screenshot crypto2.4d7864dd.png";